import SaveButton from 'components/buttons/SaveButton';
import SelectInput from 'components/input-field/SelectInput';
import TextInput from 'components/input-field/TextInput'
import { Form, Formik } from 'formik';
import React, { Component } from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { Col, Row } from 'reactstrap';
import { AddDepartmentRes, addDepartmentTodo } from 'redux/slice/super-admin/master/department/AddDepartment';
import { DepartmentSchema } from './Validation';
import Loader from 'components/loader/Loader';
import { AdminAddDepartmentRes, AdminAddDepartmentTodo } from 'redux/slice/admin/master/department/AdminAddDepartment';

class AdminAddDepartmentForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            spiner: false,
            values: {
                department: '',
                status: ''
            }
        };
    }

    status_option = [
        { "value": 'Active', "label": "Active" },
        { "value": 'Inactive', "label": "Inactive" }
    ]

    handleSubmit = (values) => {
        this.setState({ spiner: true });
        const { dispatch } = this.props;
        dispatch(AdminAddDepartmentTodo(values)).then(() => this.add_res());

    }


    add_res = () => {
        if (AdminAddDepartmentRes?.success) {
            toast.success(AdminAddDepartmentRes?.message, { position: "bottom-right" });
            setTimeout(() => {
                this.props.history.push('/admin/department-list');
            }, 1500);
            this.setState({ spiner: false });
        } else {
            toast.error(AdminAddDepartmentRes?.message, { position: "bottom-right" });
            this.setState({ spiner: false });
        }
    }

    render() {
        return (
            <>
                <div className='form_layout'>
                    {this.state.spiner ?
                        <div className='d-flex justify-content-center p-5'>
                            <Loader />
                        </div> :

                        <Formik
                            initialValues={this.state.values}
                            validationSchema={DepartmentSchema}
                            onSubmit={this.handleSubmit}
                        >
                            {({
                                values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                                <Form>
                                    <Row>
                                        <Col xl='4'>
                                            <TextInput
                                                label_name='Department'
                                                placeholder=''
                                                name='department'
                                                value={values.department || ''}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.department && touched.department ? (<span className='text-danger form_label' >{errors.department}</span>) : null}
                                            />
                                        </Col>
                                        <Col xl='4'>
                                            <SelectInput
                                                closeMenu={true}
                                                label_name='Status'
                                                disabled={false}
                                                options={this.status_option}
                                                name='status'
                                                defaultValue={''}
                                                onChange={(e) =>
                                                    setFieldValue('status', e.value)
                                                }
                                                onBlur={handleBlur}
                                                error={errors.status && touched.status ? (<span className='text-danger form_label' >{errors.status}</span>) : null} />
                                        </Col>
                                        <Col xl='12' className='d-flex justify-content-end'>
                                            <SaveButton name={'SAVE'} />
                                        </Col>
                                    </Row>
                                </Form>
                            )}
                        </Formik>
                    }
                </div>
                <ToastContainer />

            </>
        )
    }
}
export default connect()(withRouter(AdminAddDepartmentForm));
